import {useEffect, useRef} from 'react'
import PropTypes from 'prop-types'

// Singleton promise to prevent multiple script loads
let reevooScriptLoadingPromise = null

// Function to check if the Reevoo script is already in the DOM
const isReevooScriptAlreadyLoaded = (localizedReevooKey) => {
    return Boolean(document.querySelector(`script[src*="reevoo.com/loader/${localizedReevooKey}"]`))
}

// Function to dynamically load the Reevoo script
const loadReevooScript = (localizedReevooKey) => {
    if (reevooScriptLoadingPromise) return reevooScriptLoadingPromise

    reevooScriptLoadingPromise = new Promise((resolve, reject) => {
        if (isReevooScriptAlreadyLoaded(localizedReevooKey)) {
            resolve()
            return
        }
        const script = document.createElement('script')
        script.src = `https://widgets.reevoo.com/loader/${localizedReevooKey}.js`
        script.id = 'reevoo-loader'
        script.type = 'text/javascript'
        script.defer = true

        script.onload = resolve
        script.onerror = (event) => {
            console.error('Failed to load Reevoo script:', event)
            reject(new Error('Failed to load Reevoo script.'))
        }

        // Append the script to the head of the document
        document.head.appendChild(script)
    })

    return reevooScriptLoadingPromise
}

// Custom hook to load the Reevoo script
export const useReevoo = (localizedReevooKey, provider) => {
    const isInitialized = useRef(false)

    useEffect(() => {
        if (!localizedReevooKey || provider !== 'feefo') return

        if (!isInitialized.current) {
            loadReevooScript(localizedReevooKey).catch(console.error)
            isInitialized.current = true
        }
    }, [localizedReevooKey])

    return {loadReevooScript}
}

useReevoo.propTypes = {
    localizedReevooKey: PropTypes.string.isRequired,
    provider: PropTypes.string.isRequired,
}
